import { UrlPath } from '@shared/types/mylounge';

export enum ThbLinkType {
    CAMPAIGN = 'CAMPAIGN',
    TAB = 'TAB',
    URL = 'URL',
    NONE = 'NONE',
}

export interface THB {
    text: string;
    type: ThbLinkType;
    id?: string;
    url?: string;
    horizontalImage: string;
    verticalImage: string;
}

export interface CategoryTab {
    id: string;
    name: string;
    gender?: string;
    thb: THB;
}

export interface CategoryLegacy {
    id: number;
    name: string;
    image: string;
    parentId: number;
    urlPath: UrlPath;
    sortOrder: number;
    categories?: CategoryLegacy[];
}
